var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66639 7.91667H9.99973M6.66639 10.8333H12.4997M10.4164 16.6667C14.3284 16.6667 17.4997 13.4953 17.4997 9.58333C17.4997 5.67132 14.3284 2.5 10.4164 2.5C6.50438 2.5 3.33306 5.67132 3.33306 9.58333C3.33306 10.375 3.46293 11.1363 3.70254 11.8472C3.7927 12.1147 3.83779 12.2484 3.84592 12.3512C3.85395 12.4527 3.84788 12.5238 3.82277 12.6225C3.79735 12.7223 3.74122 12.8262 3.62897 13.034L2.26593 15.557C2.0715 15.9168 1.97429 16.0968 1.99604 16.2356C2.01499 16.3566 2.08618 16.4631 2.19071 16.5269C2.31071 16.6001 2.51414 16.579 2.92101 16.537L7.18853 16.0958C7.31777 16.0825 7.38238 16.0758 7.44128 16.0781C7.49921 16.0803 7.5401 16.0857 7.59659 16.0987C7.65402 16.112 7.72625 16.1398 7.87069 16.1954C8.66073 16.4998 9.51908 16.6667 10.4164 16.6667Z",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.72aeaa15888460ec05dda475b1cb5822.svg";
export { ForwardRef as ReactComponent };